/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaInputLabel/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaInputLabel({
  children,
  viewPath = "/DesignSystem/TysiaInput/TysiaInputLabel",
  width,
  text,
  marginTop,
  weight = "medium",
  size,
  required
  
}) {
let dtTysiainputlabelColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputLabel.color.primary.base'
        })
let dtColorsRed600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.600'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaInputLabel.Horizontal"
  data-view-path={viewPath}
 style={{'--w-1-Z1jsnze': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text={text}
 marginTop={marginTop}
 color={dtTysiainputlabelColorPrimaryBase}
 weight={weight}
 size={size}
 whiteSpace="nowrap"
 textOverflow="ellipsis"
 marginBottom={size === "small" ? "4px" : "4px"}
/>
<fromFlow.When is={required}>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="*"
 marginLeft="2px"
 color={dtColorsRed600}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}